import { API } from '../../../common/api/constants';

// ПОЛУЧИТЬ ВСЕХ ИСПОЛНИТЕЛЕЙ
export const GET_ALL_EXECUTORS = `${API}/authorization/company/licensee/relations/{profile_id}`;

// ПОЛУЧИТЬ ВСЕХ ИСПОЛНИТЕЛЕЙ ПО ФИЛЬТРУ
export const GET_FILTER_EXECUTORS = `${API}/authorization/company/licensee/relations/{profile_id}`;

// ПОЛУЧИТЬ ИСПОЛНИТЕЛЯ
export const GET_EXECUTOR_BY_ID = `${API}/authorization/company/licensee/relations/{company_exec_id}/profile/{profile_id}`;

// ОБНОВИТЬ ШАБЛОН ПРЕДЛОЖЕНИЯ ПО ПРОФИЛЮ ПЕРЕВОЗЧИКА
export const UPDATE_EXECUTOR = `${API}/authorization/company/executor/{company_id}/profile/{profile_id}`;

// СОЗДАТЬ ИСПОЛНИТЕЛЯ ПО ПРОФИЛЮ ПЕРЕВОЗЧИКА
export const CREATE_EXECUTOR = `${API}/authorization/company/executor/profile/{profile_id}`;

// УДАЛИТЬ ШАБЛОН ПРЕДЛОЖЕНИЯ ПО ПРОФИЛЮ ПЕРЕВОЗЧИКА
export const DELETE_TEMPLATE = `${API}/offer/template/{offer_template_id}/profile/{profile_id}`;

// ЗАГРУЗИТЬ ФОТО КОМПАНИИ
export const UPLOAD_PHOTO_COMPANY_EXECUTOR = `${API}/utility/image/upload/company`; // todo нужно новое апи привязанное к профилю
